import { render, staticRenderFns } from "./tipoPatologiaShow.vue?vue&type=template&id=665d20d9&"
import script from "./tipoPatologiaShow.vue?vue&type=script&lang=js&"
export * from "./tipoPatologiaShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports